import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { FinancingModalTrigger } from "../apps/financing/FinancingModalTrigger";

type IProps = Immutable<templates.FinancingPreQualTriggerTemplate>;

export const Template = (_props: IProps): React.JSX.Element => {
    return (
        <FinancingModalTrigger modalType="prequal-app">
            {t`Check Now`}
        </FinancingModalTrigger>
    );
};
